import { render, staticRenderFns } from "./RestaurantDetails.vue?vue&type=template&id=c0102eba&"
import script from "./RestaurantDetails.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports